+function ($) {
    /* ======= smoothScroll ======= */
    $(document).ready(function(){
        $('.how-it-works__front a').on('click', function(e){
            e.preventDefault();
            const block = $(this).parents('.how-it-works__block').first();
            block.find('.how-it-works__back').addClass('active');
            block.find('.how-it-works__front').removeClass('active');
        });
        $('.how-it-works__back a').on('click', function(e){
            e.preventDefault();
            const block = $(this).parents('.how-it-works__block').first();
            block.find('.how-it-works__back').removeClass('active');
            block.find('.how-it-works__front').addClass('active');
        });
    });
}(jQuery);
